var video_url = undefined;
var option_data = {
  type: null,
  frame: null,
  size: null
};

var international_only_profiles = ['very_large', 'specialist', 'regular_canvas', 'mounted_band_2', 'mounted_band_3', 'mounted_band_4_5', 'framed_band_2', 'framed_band_3', 'framed_band_4_5'];

var mouldings = {
  'grey': {
    name: 'Grey',
    icon: 'https://cdn.shopify.com/s/files/1/0520/1697/1925/files/grey_abbf6dcb-ab15-48a0-92a9-430076eb4eb2.png?v=1666020184'
  },
  'silver': {
    name: 'Silver',
    icon: 'https://cdn.shopify.com/s/files/1/0520/1697/1925/files/silver_f301b13d-eec7-40fe-b1c2-65056ab252ae.png?v=1666020184'
  },
  'walnut': {
    name: 'Walnut',
    icon: 'https://cdn.shopify.com/s/files/1/0520/1697/1925/files/walnut_1eee645b-c22a-4023-a60a-83e70ae98146.png?v=1666020184'
  },
  'white': {
    name: 'White',
    icon: 'https://cdn.shopify.com/s/files/1/0520/1697/1925/files/white.png?v=1668514049'
  },
  'bevelled slate': {
    name: 'Beveled Slate',
    icon: 'https://cdn.shopify.com/s/files/1/0520/1697/1925/files/Beveled_Slate.png?v=1683535153'
  },
  'bevelled truffle': {
    name: 'Beveled Truffle',
    icon: 'https://cdn.shopify.com/s/files/1/0520/1697/1925/files/Icon_d0b373d7-8ce6-46fc-a6ad-60f58b5971be.png?v=1691310495'
  },
  'square duck egg blue': {
    name: 'Square Duck Egg Blue',
    icon: 'https://cdn.shopify.com/s/files/1/0520/1697/1925/files/Icon_d24cead6-c905-4746-8b6c-df5e89efd63f.png?v=1691335318'
  },
  'bevelled blue': {
    name: 'Beveled Blue',
    icon: 'https://cdn.shopify.com/s/files/1/0520/1697/1925/files/Icon_42070bbd-4d49-4f50-a2c9-1dd19a17e010.png?v=1691335329'
  },
  'bevelled white': {
    name: 'Bevelled White',
    icon: 'https://cdn.shopify.com/s/files/1/0520/1697/1925/files/Icon_14090884-a538-417d-b2b3-7db326e44894.png?v=1691483108'
  }
};

function build_options() {
    var print_types = [];
    var print_sizes = {};
    var print_frames = [];
    document.querySelector('.product-form__option').style = "display: none;";
    for (let key of Object.keys(print_options)) {
      //Hide loose canvas prints
      if (key.indexOf('Unstretched Canvas Print') !== -1) {
        continue;
      }
      //
      if (print_options[key].type !== undefined) {
        print_types.push(print_options[key].type.replace(/['"]+/g, ''));
        if (print_options[key].size !== undefined) {
          if (print_sizes[print_options[key].type.replace(/['"]+/g, '')] === undefined) {
            print_sizes[print_options[key].type.replace(/['"]+/g, '')] = [];
          }
          print_sizes[print_options[key].type.replace(/['"]+/g, '')].push(print_options[key].size.replace(/['"]+/g, ''));
        }
      } else {
        //Sizes with no type, if needed?
      }
      if (print_options[key].frame !== undefined) {
        print_frames.push(print_options[key].frame.replace(/['"]+/g, ''));
      }
    }
    print_types = print_types.filter((v, i, a) => a.indexOf(v) === i);
    print_frames = print_frames.filter((v, i, a) => a.indexOf(v) === i);
    var print_type_element = '';
    print_type_element += '<div class="product-form__option" data-selector-type="select" id="option_type">';
    print_type_element += '  <label class="product-form__option-name text--strong">Print Type</label>';
    print_type_element += '  <div style="display: flex; flex-wrap: wrap;">';
    var first_option = true;
    for (let print_type of print_types) {
      if (first_option === true) {
        print_type_element += '    <div class="custom_option selected_custom_option" onclick="switch_print_type(`' + print_type + '`)" data-tag="type" data-type="' + print_type + '">';
        option_data.type = print_type;
        first_option = false;
      } else {
        print_type_element += '    <div class="custom_option" onclick="switch_print_type(`' + print_type + '`)" data-tag="type" data-type="' + print_type + '">';
      }
      print_type_element += '      <img onmousedown="return false" src="' + get_icon(print_type) + '"></img>';
      print_type_element += '      <p class="custom_option_text" onmousedown="return false">' + print_type + '</p>';
      print_type_element += '    </div>';
    }
    print_type_element += '  </div>';
    print_type_element += '</div>';
    document.querySelectorAll('.product-form__variants')[0].innerHTML += print_type_element;

    var print_size_element = '';
    print_size_element += '<div class="product-form__option" data-selector-type="select" id="option_size">';
    print_size_element += '  <label class="product-form__option-name text--strong">Size</label>';
    print_size_element += '  <div style="display: flex;">';
    first_option = true;
    for (let key of Object.keys(print_sizes)) {
      print_size_element += '<div class="size_group" id="size_group_' + key + '" style="display: none;">';
      for (let size of print_sizes[key].filter((v, i, a) => a.indexOf(v) === i)) {
        if (first_option === true) {
          print_size_element += '    <div class="custom_option selected_custom_option" onclick="switch_print_size(`' + size + '`)" data-type="' + key + '" data-tag="size" data-size="' + size + '">';
          option_data.size = size;
          first_option = false;
        } else {
          print_size_element += '    <div class="custom_option" onclick="switch_print_size(`' + size + '`)" data-type="' + key + '" data-tag="size" data-size="' + size + '">';
        }
        print_size_element += '      <p>' + size + '</p>';
        print_size_element += '    </div>';
      }
      print_size_element += '    <div class="custom_option button button--primary view_similar_sizes" onclick="view_similar_sizes()" style="display: none;">';
      print_size_element += '      <p style="padding: 0; background: none;">View Other Similarly Sized Prints</p>';
      print_size_element += '    </div>';
      print_size_element += '  </div>';
    }
    print_size_element += '  </div>';
    print_size_element += '</div>';
    document.querySelectorAll('.product-form__variants')[0].innerHTML += print_size_element;

    var print_frame_element = '';
    print_frame_element += '<div class="product-form__option" data-selector-type="select" id="option_frame">';
    print_frame_element += '  <label class="product-form__option-name text--strong">Frame - <span id="moulding"></span></label>';
    print_frame_element += '  <div style="display: flex;">';
    first_option = true;
    for (let print_frame of print_frames) {
      if ((print_frame === 'white') || (print_frame === 'walnut') || (print_frame === 'grey') || (print_frame === 'silver')) {
        var bespoke_tag = 'not_bespoke';
      } else {
        var bespoke_tag = 'is_bespoke';
      }
      if (first_option === true) {
        print_frame_element += '    <div class="custom_option ' + bespoke_tag + '" onclick="switch_print_frame(`' + print_frame + '`)" data-tag="frame" data-type="' + print_frame + '">';
        option_data.frame = print_frame;
        first_option = false;
      } else {
        print_frame_element += '    <div class="custom_option ' + bespoke_tag + '" onclick="switch_print_frame(`' + print_frame + '`)" data-tag="frame" data-type="' + print_frame + '">';
      }
      print_frame_element += '      <img onmousedown="return false" src="' + mouldings[print_frame].icon + '"></img>';
      print_frame_element += '    </div>';
    }
    print_frame_element += '  </div>';
    print_frame_element += '</div>';
    document.querySelectorAll('.product-form__variants')[0].innerHTML += print_frame_element;
    //video_element = '<div class="button button--primary" onclick="view_video()" id="video_button">View Print in 360°</div>';
    //document.querySelectorAll('.product-form__variants')[0].innerHTML += video_element;
}

var band = 0;
function update_selected() {
  var select_option = 1;
  var video = null;
  for (let key of Object.keys(print_options)) {
    if (print_options[key].type.split('"').join('') === option_data.type) {
      if (print_options[key].size.split('"').join('') === option_data.size) {
        if ((option_data.type === 'framed') || (option_data.type === 'bespoke')) {
          if (print_options[key].frame.split('"').join('') === option_data.frame) {
            data = print_options[key];
            video = print_options[key].print_video;
            break;
          }
        } else {
          data = print_options[key];
          video = print_options[key].print_video;
          break;
        }
      }
    }
    select_option += 1;
  }

  band = 0;
  if ((data.type === 'framed') && (data.price === 5000)) {
    band = 1;
  }
  if ((data.type === 'framed') && (data.price === 7000)) {
    band = 2;
  }
  if ((data.type === 'framed') && (data.price === 11000)) {
    band = 3;
  }
  if ((data.type === 'framed') && (data.price === 14500)) {
    band = 4;
  }
  if ((data.type === 'framed') && (data.price === 16500)) {
    band = 5;
  }
  if ((data.type === 'mounted') && (data.price === 3000)) {
    band = 1;
  }
  if ((data.type === 'mounted') && (data.price === 4000)) {
    band = 2;
  }
  if ((data.type === 'mounted') && (data.price === 5000)) {
    band = 3;
  }
  if ((data.type === 'mounted') && (data.price === 7500)) {
    band = 4;
  }
  if ((data.type === 'mounted') && (data.price === 8500)) {
    band = 5;
  }
  
  if (band === 0) {
    for (let c of document.getElementsByClassName('view_similar_sizes')) {
      c.style.display = 'none';
    }
  } else {
    for (let c of document.getElementsByClassName('view_similar_sizes')) {
      c.style.display = 'block';
    }
  }

  /*
  if (video === undefined) {
    document.getElementById('video_button').style.display = 'none';
  } else {
    document.getElementById('video_button').style.display = 'block';
  }
  video_url = video;
  */
  
  if (typeof mouldings[option_data.frame] !== 'undefined') {
    document.getElementById('moulding').innerHTML = mouldings[option_data.frame].name;
  }
  document.querySelectorAll('#' + document.getElementById('print_option_select').querySelector('select').id + ' > option:nth-child(' + select_option + ')')[0].selected = true;
  document.querySelectorAll('#' + document.querySelector('.print_option_select_njs').id + ' > option:nth-child(' + select_option + ')')[0].selected = true;
  document.querySelector('#' + document.getElementById('print_option_select').querySelector('select').id).dispatchEvent(new Event("change", {
  	view: window,
  	bubbles: true,
  	cancelable: false
  }));
}

function update_options() {
  if ((option_data.type === 'framed') || (option_data.type === 'bespoke')) {
    document.getElementById('option_frame').style = "display: block;";
  } else {
    document.getElementById('option_frame').style = "display: none;";
  }
  for (let size_option of document.querySelectorAll('.size_group')) {
    size_option.style = "display: none;";
  }
  if (document.getElementById('size_group_' + option_data.type) !== null) {
    document.getElementById('size_group_' + option_data.type).style = 'display: block;';
  }
}

function switch_print_type(print_type) {
  for (let element of document.querySelectorAll('[data-tag="type"]')) {
      element.classList.remove('selected_custom_option');
  }
  option_data.type = print_type;
  if (option_data.type === 'framed') {
    $('.is_bespoke').addClass('hidden');
    $('.not_bespoke').removeClass('hidden');
  }
  if (option_data.type === 'bespoke') {
    $('.is_bespoke').removeClass('hidden');
    $('.not_bespoke').addClass('hidden');
  }
  document.querySelectorAll('[data-tag="type"][data-type="' + print_type + '"]')[0].classList.add('selected_custom_option');
  
  if (option_data.type === 'framed') {
    if ($('.custom_option.not_bespoke.selected_custom_option').length === 0) {
      $('.is_bespoke').removeClass('selected_custom_option');
      $('.custom_option.not_bespoke')[0].classList.add('selected_custom_option');
    }
  }
  if (option_data.type === 'bespoke') {
    if ($('.custom_option.is_bespoke.selected_custom_option').length === 0) {
      $('.not_bespoke').removeClass('selected_custom_option');
      $('.custom_option.is_bespoke')[0].classList.add('selected_custom_option');
    }
  }
  if ($('#option_frame .selected_custom_option').length > 0) {
    option_data.frame = $('#option_frame .selected_custom_option')[0].dataset.type;
  }

  update_options();
  
  for (let element of document.querySelectorAll('[data-tag="size"]')) {
      element.classList.remove('selected_custom_option');
  }
  if (document.querySelectorAll('[data-tag="size"][data-type="' + print_type + '"]').length !== 0) {
    document.querySelectorAll('[data-tag="size"][data-type="' + print_type + '"]')[0].classList.add('selected_custom_option');
    option_data.size = document.querySelectorAll('[data-tag="size"][data-type="' + print_type + '"]')[0].dataset.size;
  } else {
    option_data.size = 'Standard';
  }
  
  update_selected();
}

function switch_print_frame(print_frame) {
  for (let element of document.querySelectorAll('[data-tag="frame"]')) {
      element.classList.remove('selected_custom_option');
  }
  option_data.frame = print_frame;
  document.querySelectorAll('[data-tag="frame"][data-type="' + print_frame + '"]')[0].classList.add('selected_custom_option');
  update_options();
  update_selected();
}

function switch_print_size(print_size) {
  for (let element of document.querySelectorAll('[data-tag="size"]')) {
      element.classList.remove('selected_custom_option');
  }
  option_data.size = print_size;
  document.querySelectorAll('[data-tag="size"][data-type="' + option_data.type + '"][data-size="' + print_size + '"]')[0].classList.add('selected_custom_option');
  update_options();
  update_selected();
}

function get_icon(print_type) {
  if (print_icons[print_type] !== undefined) {
    if (print_icons[print_type].length !== 0) {
      return print_icons[print_type];
    }
  }
  return 'https://via.placeholder.com/96?text=' + print_type;
}

function view_video() {
  if (video_url === undefined) {
    return;
  }
  var video = document.getElementById('video_video');
  var source = document.createElement('source');
  source.setAttribute('src', video_url);
  source.setAttribute('type', 'video/mp4');
  video.appendChild(source);
  video.currentTime = 0;
  video.play();
  document.getElementById('video_container').style.display = "block";
}



//Add in custom variant selection menus

function switch_selected_variant(variant, id) {
  for (let option of document.querySelectorAll('.custom_option_slim')) {
      option.classList.remove('selected_custom_option_slim');
  }
  document.querySelector('.variant_option_' + id).classList.add('selected_custom_option_slim');
  document.querySelector('.variant_option_select select').value = variant;
  document.querySelector('.print_option_select_njs').value = id;
  document.querySelector('.variant_option_select select').dispatchEvent(new Event("change", {
  	view: window,
  	bubbles: true,
  	cancelable: false
  }));
  update_shipping_notice();
}

function update_shipping_notice() {
  var profile = metadata[document.getElementsByClassName("product-form__single-selector")[0].value];
  if (currency === 'GBP') {
    return;
  }
  if (international_only_profiles.includes(profile)) {
    document.getElementById('shipping_notice').style.display = 'block';
  } else {
    document.getElementById('shipping_notice').style.display = 'none';
  }
}

function  view_similar_sizes() {
  window.location.href = ('/collections/size-band-' + band);
}

if (typeof print_options !== 'undefined') {
  build_options();
  update_options();
  update_selected();
}